import { Modal, Button } from "react-bootstrap";

import "./index.scss";

const ErrorModal = ({ show, onClose, message }) => {
  return (
    <Modal
      centered
      show={show}
      onHide={onClose}
      className="certificate-error-modal"
    >
      <Modal.Header className="certificate-error-modal__header" closeButton>
        <Modal.Title className="certificate-error-modal__title">
          Warning!
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="certificate-error-modal__body">
        <div className="certificate-error-modal__icon">
          <img
            alt="Error"
            width="50"
            height="50"
            src={require("../../../../assets/gif/Warning.gif")}
          />
        </div>
        <div className="certificate-error-modal__message">{message}</div>
      </Modal.Body>

      <Modal.Footer className="certificate-error-modal__footer">
        <Button
          className="certificate-error-modal__close-btn"
          variant="primary"
          onClick={onClose}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
